export default "__VITE_ASSET__DMp6f2nN__"